import { render, staticRenderFns } from "./EventsDetail.vue?vue&type=template&id=0b88a996&scoped=true&"
import script from "./EventsDetail.vue?vue&type=script&lang=js&"
export * from "./EventsDetail.vue?vue&type=script&lang=js&"
import style0 from "./EventsDetail.vue?vue&type=style&index=0&id=0b88a996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88a996",
  null
  
)

export default component.exports